'use strict';
require('../../../modules/es.array.sort');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');

module.exports = getBuiltInPrototypeMethod('Array', 'sort');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/sort.js
// module id = 565
// module chunks = 13